"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewContentCommand = void 0;
const generate_content_1 = require("../utils/generate-content");
class ViewContentCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { viewType, contents, customer, value, total_quantity, article_data, content_name, content_category } = this.input;
        const { cdp: cdpTracking } = config;
        const hashCustomerId = cdpTracking?.helper.md5(customer?.id ?? '');
        const customerData = customer
            ? {
                customer_id: customer?.id ? hashCustomerId : 'no-customer-id',
                name: customer?.name ?? 'no-customer-name',
                email: customer?.email?.toLowerCase() ?? 'no-customer-email',
                phone: customer?.phone ?? 'no-customer-phone',
                cdp_source: 'Production',
            }
            : {};
        switch (viewType) {
            case 'ViewContent': {
                cdpTracking?.web_event.track('product', 'view', {
                    items: contents?.map((content) => ({
                        ...(0, generate_content_1.generateContentItem)(content),
                        cdp_source: 'Production',
                    })) ?? [],
                    ...(customer && {
                        dims: {
                            customers: customerData
                        }
                    }),
                    extra: {},
                });
                break;
            }
            case 'ViewCart': {
                cdpTracking?.web_event.track('product', 'view_cart', {
                    items: contents?.map((content) => ({
                        ...(0, generate_content_1.generateContentItem)(content),
                        cdp_source: 'Production',
                        quantity: content.quantity,
                    })) ?? [],
                    ...(customer && {
                        dims: {
                            customers: customerData
                        }
                    }),
                    extra: {
                        cart_subtotal: value,
                        cart_item_count: total_quantity,
                    },
                });
                break;
            }
            case 'ViewArticle': {
                cdpTracking?.web_event.track('article', 'view', {
                    items: [
                        {
                            id: contents?.at(0)?.id ?? 'no-id-content',
                            name: content_name ?? 'no-content-name',
                            type: 'article',
                            title: article_data?.title ?? 'no-title',
                            category: content_category ?? 'no-content-category',
                            page_url: article_data?.page_url ?? 'no-page-url',
                            tags: article_data?.tags ?? [],
                            tags_string: article_data?.tags?.join(','),
                            keywords: article_data?.keywords ?? [],
                            keywords_string: article_data?.keywords?.join(','),
                            cdp_source: 'Production',
                        },
                    ],
                    ...(customer && {
                        dims: {
                            customers: customerData
                        }
                    }),
                    extra: {
                        page_title: article_data?.title ?? 'no-title',
                        keywords: article_data?.keywords ?? [],
                        keywords_string: article_data?.keywords?.join(','),
                        blog_title: article_data?.title ?? 'no-title',
                        blog_category: content_category ?? 'no-content-category',
                    },
                });
                break;
            }
            case 'ViewPage': {
                cdpTracking?.web_event.track('pageview', 'view', {});
                break;
            }
            default: {
                break;
            }
        }
        return Promise.resolve();
    }
}
exports.ViewContentCommand = ViewContentCommand;
